import { useState, useEffect } from "react";
import {
    Box,
    Button,
    Typography,
    Card,
    CardContent,
    CardMedia,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    IconButton,
    Grid2,
    Tooltip,
    CircularProgress
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { myApi } from '../../config/axiosConfig';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

import MyNumberInput from "../../components/inputs/MyNumberInput";
import MyNumberInputFormat from "../../components/inputs/MyNumberInputFormat.jsx";
import MyQRScanner from '../../components/inputs/MyQRScanner';

import TireModal from "./modal/TireModal"; 
import AssignModal from "./modal/AssignModal"; 

import useUser from "../../hooks/useUser";

import Navbar from '../../components/Navbar';

const Login = () => {


    const user = useUser();

    const navigate = useNavigate();

    const [selectedTireIndex, setSelectedTireIndex] = useState(null);
    const [selectedTireLabel, setSelectedTireLabel] = useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const [modalOpen2, setModalOpen2] = useState(false);

    const [currentStepIndex, setCurrentStepIndex] = useState(0);
    const [stepData, setStepData] = useState([]);
    const [unitType, setUnitType] = useState(null);

    const [isSubmitting, setIsSubmitting] = useState(false);

    let idUser = user?.idUser;

    const stepTractor = [
        {
            id: 1,
            title: "Escanee el código QR, por favor.",
            description:
                "Dé clic en INICIAR ESCANEO y coloque el código de QR del Tractor en la cámara.",
            photoRequired: false,
            inputs: [
                { label: "QR", key: "qrNumber", type: "qr" },
            ],
            photoKey: "photos_qr"
        },
        {
            id: 2,
            title: "Tome una foto del lugar donde se coloque el QR, por favor.",
            description:
                "Capture una imagen clara del lugar donde se coloca el código QR en la Unidad.",
            photoRequired: true,
            photoKey: "photos_qrTruck"
        },
        {
            id: 3,
            title: "Tome una foto del odómetro actual del Tractor.",
            description:
                "Capture una imagen de la lectura del odómetro del Tractor y escriba el número registrado.",
            photoRequired: true,
            inputs: [
                { label: "Número Odómetro", key: "odometerNumber", type: "numberFormat" },
            ],
            photoKey: "photos_odometerNumber"
        },
        {
            id: 4,
            title: "Fotos del Walkaround.",
            description: "Iniciaremos el proceso de toma de fotos del tractor, haga clic en el botón OK para continuar.",
        },
        {
            id: 5,
            title: "Tome foto(s) del LADO IZQUIERDO del Tractor.",
            description:
                "Capture una o varias imagen(es) clara(s) del lado izquierdo de la Unidad.",
            photoRequired: true,
            photoExample: "/img/Truck_driver_side.png",
            photoKey: "photos_leftSide"
        },
        {
            id: 6,
            title: "Tome foto(s) de la PARTE TRASERA del Tractor.",
            description:
                "Capture una o varias imagen(es) clara(s) de atrás de la Unidad.",
            photoRequired: true,
            photoExample: "/img/Truck_rear.png",
            photoKey: "photos_back"
        },
        {
            id: 7,
            title: "Tome foto(s) del LADO DERECHO del Tractor.",
            description:
                "Capture una o varias imagen(es) clara(s) del lado derecho de la Unidad.",
            photoRequired: true,
            photoExample: "/img/Truck_passenger_side.png",
            photoKey: "photos_rightSide"
        },
        {
            id: 8,
            title: "Tome foto(s) de la PARTE FRONTAL del Tractor.",
            description:
                "Capture una o varias imagen(es) clara(s) de enfrente de la Unidad.",
            photoRequired: true,
            photoExample: "/img/Truck_front.png",
            photoKey: "photos_front"
        },
        {
            id: 9,
            title: "Tome foto(s) del TABLERO DE LA CABINA del Tractor.",
            description:
                "Capture una o varias imagen(es) clara(s) de tablero de la cabina de la Unidad.",
            photoRequired: true,
            photoExample: "/img/Truck_cabin_dash.png",
            photoKey: "photos_cabin_dash"
        },
        {
            id: 10,
            title: "Tome foto(s) de la PARTE TRASERA DE LA CABINA del Tractor.",
            description:
                "Capture una o varias imagen(es) clara(s) de la parte trasera de la cabina de la Unidad.",
            photoRequired: true,
            photoExample: "/img/Truck_cabin_rear.png",
            photoKey: "photos_cabin_rear"
        },
        {
            id: 11,
            title: "Fotos de las Llantas.",
            description: "Iniciaremos el proceso de toma de fotos de las llantas del tractor, haga clic en el botón OK para continuar.",
        },
        {
            id: 12,
            title: "Tome foto(s) de cada LLANTA desde la vista aérea del Tractor.",
            description:
              "Capture una imagen clara de cada lado de las llantas del tractor desde la vista aérea. Presione cada botón sobre la imagen para tomar una foto correspondiente.",
            photoTiresTopView: true,
            photoKey: "topTirePhotos",
            photoExample: "/img/aereo.png",
            final: true,
        }
    ];

    const stepCaja = 
    [
        {
            id: 1,
            title: "Escanee el código QR, por favor.",
            description:
                "Dé clic en INICIAR ESCANEO y coloque el código de QR de la Caja en la cámara.",
            photoRequired: false,
            inputs: [
                { label: "QR", key: "qrNumber", type: "qr" },
            ],
            photoKey: "photos_qr"
        },
        {
            id: 2,
            title: "Tome una foto del lugar donde se coloque el QR, por favor.",
            description:
                "Capture una imagen clara del lugar donde se coloca el código QR en la Unidad.",
            photoRequired: true,
            photoKey: "photos_qrTrailer"
        },
        {
            id: 3,
            title: "Fotos del Walkaround.",
            description: "Iniciaremos el proceso de toma de fotos del Remolque, haga clic en el botón OK para continuar.",
        },
        {
            id: 4,
            title: "Tome foto(s) del LADO IZQUIERDO del Remolque.",
            description:
                "Capture una o varias imagen(es) clara(s) del lado izquierdo de la Unidad.",
            photoRequired: true,
            photoExample: "/img/Trailer_driver_side.png",
            photoKey: "photos_leftSide"
        },
        {
            id: 5,
            title: "Tome foto(s) de la PARTE TRASERA del Remolque.",
            description:
                "Capture una o varias imagen(es) clara(s) de atrás de la Unidad.",
            photoRequired: true,
            photoExample: "/img/Trailer_rear.png",
            photoKey: "photos_back"
        },
        {
            id: 6,
            title: "Tome foto(s) del LADO DERECHO del Remolque.",
            description:
                "Capture una o varias imagen(es) clara(s) del lado derecho de la Unidad.",
            photoRequired: true,
            photoExample: "/img/Trailer_passenger_side.png",
            photoKey: "photos_rightSide"
        },
        {
            id: 7,
            title: "Tome foto(s) de la PARTE FRONTAL del Remolque.",
            description:
                "Capture una o varias imagen(es) clara(s) de enfrente de la Unidad.",
            photoRequired: true,
            photoExample: "/img/Trailer_front.png",
            photoKey: "photos_front"
        },
        {
            id: 8,
            title: "Fotos de las Llantas.",
            description: "Iniciaremos el proceso de toma de fotos de las llantas del Remolque, haga clic en el botón OK para continuar.",
        },
        {
            id: 9,
            title: "Tome foto(s) de cada LLANTA desde la vista aérea del Remolque.",
            description:
              "Capture una imagen clara de cada lado de las llantas de la caja desde la vista aérea. Presione cada botón sobre la imagen para tomar una foto correspondiente.",
            photoTiresTopView: true,
            photoKey: "topTirePhotos",
            photoExample: "/img/Trailer_aereo.png",
            final: true,
        }
    ];

    const steps = unitType === "tractor" ? stepTractor : stepCaja;

    // Obtener el paso actual o null si no existe
    const currentStep = steps[currentStepIndex] || null;

    const photoKey = currentStep?.photoKey || "photos";

    const findTractor = async (tractorQR) => 
    {
        try 
        {
            // 1. Verifica si existe en catálogo
            const catalogoResponse = await myApi.get(`/alta_unidad/buscarTractor?tractor=${tractorQR}`);
            const existeEnCatalogo = catalogoResponse.data?.data?.cuantos > 0;
    
            if (!existeEnCatalogo) {
                Swal.fire({
                    icon: 'error',
                    title: '¡Error!',
                    text: 'El tractor no existe en el catálogo.',
                });
                return false;
            }
    
            // 2. Verifica si ya fue dado de alta
            const altaResponse = await myApi.get(`/alta_unidad/verificar/qr/${tractorQR}`);
            const yaRegistrado = altaResponse.data?.alreadyRegistered;
    
            if (yaRegistrado) {
                Swal.fire({
                    icon: 'warning',
                    title: 'QR duplicado',
                    text: 'Este QR ya fue dado de alta anteriormente.',
                });
                return false;
            }
    
            Swal.fire({
                icon: 'success',
                title: `¡QR válido: Tractor ${tractorQR}!`,
                text: 'Puede continuar con el alta. Dé clic en el botón "SIGUIENTE".',
            });
            return true;
    
        } catch (error) {
            console.error("Error en findTractor:", error);
            Swal.fire({
                icon: 'error',
                title: 'Error de validación',
                text: 'Ocurrió un error al validar el QR.',
            });
            return false;
        }
    };
    
    const findTrailer = async (trailerQR) => 
    {
        try {
          // 1. Verifica si existe en catálogo
          const catalogoResponse = await myApi.get(`/alta_unidad/buscarCaja?caja=${trailerQR}`);
          const existeEnCatalogo = catalogoResponse.data?.data?.cuantos > 0;
      
          if (!existeEnCatalogo) {
            Swal.fire({
              icon: 'error',
              title: '¡Error!',
              text: 'La caja no existe en el catálogo.',
            });
            return false;
          }
      
          // 2. Verifica si ya fue dada de alta
          const altaResponse = await myApi.get(`/alta_unidad/verificar/qr/${trailerQR}`);
          const yaRegistrado = altaResponse.data?.alreadyRegistered;
      
          if (yaRegistrado) {
            Swal.fire({
              icon: 'warning',
              title: 'QR duplicado',
              text: 'Este QR ya fue dado de alta anteriormente.',
            });
            return false;
          }
      
        Swal.fire({
            icon: 'success',
            title: `¡QR válido: REMOLQUE ${trailerQR}!`,
            text: 'Puede continuar con el alta. Dé clic en el botón "SIGUIENTE".',
        });
        return true;
      
        } catch (error) {
          console.error('Error en findTrailer:', error);
          Swal.fire({
            icon: 'error',
            title: 'Error de validación',
            text: 'Ocurrió un error al validar el QR.',
          });
          return false;
        }
    
    };

    /*
    const buildStructuredPayload = (stepData, stepConfig) => {
        return stepConfig.map((step, i) => {
          const raw = stepData[i] || {};
      
          const entry = {
            stepId: step.id,
            timestamp: new Date().toISOString(),
            photos: [],
            inputs: {},
          };
      
          if (step.photoKey && raw[step.photoKey]) {
            if (step.photoTiresTopView) {
              entry.tires = (raw[step.photoKey] || []).map((tire, index) => ({
                ...tire,
                positionIndex: index,
              }));
            } else {
              entry.photos = raw[step.photoKey];
            }
          }
      
          if (step.inputs) {
            step.inputs.forEach((input) => {
              if (raw[input.key] !== undefined) {
                entry.inputs[input.key] = raw[input.key];
              }
            });
          }
      
          return entry;
        });
    };
    */

    const buildStructuredPayload = (stepData, stepConfig) => 
    {
        return stepConfig.map((step, i) => {
            const raw = stepData[i] || {};

            const entry = {
            stepId: step.id,
            title: step.title,
            photos: [],
            tires: [],
            inputs: {},
            };

            if (step.photoKey && raw[step.photoKey]) {
            if (step.photoTiresTopView) {
                entry.tires = (raw[step.photoKey] || []).map((tire, index) => ({
                ...tire,
                positionIndex: index,
                }));
            } else {
                entry.photos = raw[step.photoKey];
            }
            }

            if (step.inputs) {
            step.inputs.forEach((input) => {
                if (raw[input.key] !== undefined) {
                entry.inputs[input.key] = raw[input.key];
                }
            });
            }

            // Asegurar que unidadSeleccionada se pase si existe
            if (raw?.inputs?.unidadSeleccionada) {
            entry.inputs.unidadSeleccionada = raw.inputs.unidadSeleccionada;
            }

            return entry;
        });
    };

    /*
    const buildStructuredPayload = (stepData, stepConfig) => 
    {
        return stepConfig.map((step) => 
        {
            const stepValues = stepData.find((d) => d.stepId === step.id) || {};

            const entry = 
            {
                stepId: step.id,
                title: step.title,
                photos: (stepValues.photos || []).map((p) => ({
                    nombre_archivo: p.nombre_archivo || "",
                    ruta: p.ruta || "",
                    file: p.file || null,
                })),
                tires: (stepValues.topTirePhotos || []).map((tire) => ({
                    marca_id: tire.marca_id || "",
                    tipo_material: tire.tipo_material ?? true,
                    fotos: (tire.fotos || []).map((foto) => ({
                        file: foto.file || null,
                        url: foto.url || "",
                    })),
                    label: tire.label || "",
                })),
                inputs: {},
            };

            if (step.inputs) 
            {
                step.inputs.forEach((input) => 
                {
                    if (stepValues[input.key] !== undefined) 
                    {
                        entry.inputs[input.key] = stepValues[input.key];
                    }
                });
            }

            if (stepValues.inputs?.unidadSeleccionada) 
            {
                entry.inputs.unidadSeleccionada = stepValues.inputs.unidadSeleccionada;
            }

            return entry;
        });
    };*/

    const handleSubmitForm = async () => {

        if (!unitType) 
        {
            Swal.fire({
              icon: 'error',
              title: 'Tipo de unidad no definido',
              text: 'Por favor selecciona si es tractor o remolque.',
            });
            return; 
        }

        const stepConfig = unitType === "remolque" ? stepCaja : stepTractor;
        const structuredData = buildStructuredPayload(stepData, stepConfig);

        console.log("✅ JSON estructurado:", structuredData);
      
        const formData = new FormData();
        formData.append("formData", JSON.stringify(structuredData));
        formData.append("unitType", unitType);

        formData.append("idUser", idUser);
      
        // Agrupar archivos
        const photoFiles = [];
        const tireFiles = [];
      
        structuredData.forEach((step) => {
          // Fotos generales
          (step.photos || []).forEach((photo) => {
            if (photo?.file) {
              photoFiles.push(photo.file);
            }
          });
      
          // Fotos de llantas
          (step.tires || []).forEach((tire) => {
            (tire.fotos || []).forEach((foto) => {
                if (foto?.file) {
                tireFiles.push(foto.file);
                }
            });
          });
          /*
          (step.tires || []).forEach((tire) => {
            if (tire?.file) {
              tireFiles.push(tire.file);
            }
          });
          */
        });
      
        // Agrega fotos normales
        photoFiles.forEach((file) => {
          formData.append("photos", file);
        });
      
        // Agrega fotos de llantas
        tireFiles.forEach((file) => {
          formData.append("tirePhotos", file);
        });
      
        try {
          Swal.fire({
            title: 'Guardando sus datos...',
            text: 'Por favor, espere mientras se almacena la información.',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
          });

          const result = await myApi.post("/alta_unidad/guardar/datos/unidad", formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
      
          Swal.close();
      
          if (result.data.success) {
            Swal.fire({ icon: 'success', title: '¡Información guardada exitosamente!' });
            setCurrentStepIndex(0);
            setStepData([]);
            setUnitType(null);
            navigate('./');
          } else {
            Swal.fire({ icon: 'error', title: 'Error al intentar guardar la información.' });
          }
        } catch (error) {
          Swal.close();
          const errorMessage = error.response?.data?.message || error.message || 'Error desconocido';

            Swal.fire({
            icon: 'error',
            title: 'No se pudo guardar la información.',
            text: errorMessage,
            });
        }
    };
      

    /*
    const handleSubmitForm = async () => {
        const structuredData = buildStructuredPayload(stepData, stepTractor);
      
        console.log("📦 Payload final:", structuredData); // ✅ este es el JSON organizado que puedes enviar a Node.js
      
        /*
        // Si usas FormData con fotos reales:
        const formData = new FormData();
      
        // Si tienes fotos como archivos, agrégalas a formData aquí...
      
        // Luego lo puedes enviar:
        // await myApi.post("/ruta/del/backend", formData);

        // Agregar JSON con la estructura organizada
        formData.append("formData", JSON.stringify(structuredData));

        // Agregar archivos individuales
        allFiles.forEach((file, index) => {
            formData.append("photos", file); // puedes cambiar "photos" por "files[]" si tu backend lo espera así
        });

        try 
        {
            Swal.fire({
                title: 'Guardando sus datos...',
                text: 'Por favor, espere mientras se almacena la información.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });

            const result = await myApi.post('/alta_unidad/guardar/datos', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            Swal.close();

            if (result.data.success) {
                Swal.fire({ icon: 'success', title: '¡Información guardada exitosamente!' });
                setCurrentStepIndex(0);
                setStepData([]);
                setUnitType(null);
                navigate('/login');
            } else {
                Swal.fire({ icon: 'error', title: 'Error al intentar guardar la información.' });
            }
        } catch (error) {
            Swal.close();
            Swal.fire({ icon: 'error', title: 'Error al intentar guardar la información.', text: error.message });
        }
            

    };*/

    /*
    const handlePhotoUpload = (event, values, setFieldValue, field = "photos") => {
        const files = event.target.files;
      
        if (files) {
          const newPhotos = Array.from(files).map((file) => ({
            file,
            url: URL.createObjectURL(file),
            name: `${file.name}`,
          }));
          setFieldValue(field, [...(values[field] || []), ...newPhotos]);
        }
    };
    */

    const handlePhotoUpload = (event, values, setFieldValue, field = "photos") => 
    {
        const files = event.target.files;

        if (files && files.length > 0) {
            const newPhotos = Array.from(files).map((file) => ({
            file,
            url: URL.createObjectURL(file),
            name: `${Date.now()}-${Math.random()}-${file.name}`, // Nombre único
            }));

            const existingPhotos = values[field] || [];

            // Evitar duplicados por referencia del mismo File
            const mergedPhotos = [...existingPhotos, ...newPhotos].filter(
            (photo, index, arr) => arr.findIndex(p => p.file === photo.file) === index
            );

            setFieldValue(field, mergedPhotos);
        }

        // 👇 importante para iOS, esto debes hacerlo donde llamas esta función:
        // e.target.value = null;
    };

    const handleOnChangeUnitType = async (e) => {
        let unitType = e;
        setUnitType(unitType);
    };

    const handleNext = async (values, { setTouched, validateForm }) => {
        const photoKey = currentStep?.photoKey || "photos";
    
        // Marcar como touched todos los campos relevantes
        const stepTouched = {
            ...(currentStep.photoRequired ? { [photoKey]: true } : {}),
            ...(currentStep.inputs || []).reduce((acc, input) => {
                acc[input.key] = true;
                return acc;
            }, {}),
        };
    
        setTouched(stepTouched, true); // <- Esto activa los errores visuales
    
        const errors = await validateForm();
    
        if (Object.keys(errors).length > 0) {
            console.log("Errores:", errors); // <- Verifica si llega hasta aquí
            return; // No avanzar si hay errores
        }

        console.log(values)
        //if (currentStepIndex === 0 && !stepData?.[0]?.inputs?.unidadSeleccionada) 
        //if (currentStepIndex === 0 && !values?.inputs?.unidadSeleccionada) 
        //if (currentStepIndex === 0 && !(values?.inputs && values.inputs.unidadSeleccionada))
        if (currentStepIndex === 0 && !values.unidadSeleccionada) 
        {
            Swal.fire({
            icon: 'warning',
            title: 'Asignación pendiente',
            text: 'Debe asignar una unidad antes de continuar.',
            });
            return;
        }
      
        // Guardar los datos del paso actual
        const updatedStepData = [...stepData];
        updatedStepData[currentStepIndex] = values;
        setStepData(updatedStepData);
    
        // Avanzar al siguiente paso
        if (currentStepIndex < steps.length - 1) {
            setCurrentStepIndex((prev) => prev + 1);
        }
    };

    /*
    const handlePrev = () => {
        if (currentStepIndex > 0) {
            setCurrentStepIndex(currentStepIndex - 1);
        }
    };*/
/*
    const handlePrev = () => {
    if (currentStepIndex > 0) {
        // Si estás en el paso 2 y regresas al 1
        if (currentStepIndex === 1) {
            // Limpiar unidad asignada del paso 0
            const updatedStepData = [...stepData];
            if (updatedStepData[0]?.inputs) {
                delete updatedStepData[0].inputs.unidadSeleccionada;
            }

            // También limpia sessionStorage si lo estás usando
            sessionStorage.removeItem("unidadAsignada");
            sessionStorage.removeItem("qrPendienteAsignado");

            setStepData(updatedStepData);
        }

        setCurrentStepIndex((prev) => prev - 1);
    }
};*/

const handlePrev = () => {
      if (currentStepIndex > 0) {
        if (currentStepIndex === 1) {
          // Borrar campo en Formik
          //setFieldValue("unidadSeleccionada", "");

          // Borrar en stepData
          const updatedStepData = [...stepData];
          if (updatedStepData[0]?.inputs) {
            delete updatedStepData[0].inputs.unidadSeleccionada;
          }

          sessionStorage.removeItem("unidadAsignada");
          sessionStorage.removeItem("qrPendienteAsignado");

          setStepData(updatedStepData);
        }

        setCurrentStepIndex((prev) => prev - 1);
      }
    };

    const validateTires = (tires = [], tirePositions) => {
        const incompleteLabels = [];
      
        tirePositions.forEach((pos) => {
          const tire = tires[pos.id] || {};
          const hasMarca = !!tire.marca_id;
          const hasFotos = Array.isArray(tire.fotos) && tire.fotos.length > 0;

          const isComplete = hasMarca && hasFotos;
    
          if (!isComplete) {
            incompleteLabels.push(pos.label);
          }
        });
      
        return {
          isValid: incompleteLabels.length === 0,
          incompleteLabels,
        };
    };

    // Definir posiciones para cada tipo
    const tirePositionsTruck = [
        { id: 0, label: 'Pos. 2', top: '23%', left: '19%' },
        { id: 1, label: 'Pos. 1', top: '90%', left: '19%' },
        { id: 2, label: 'Pos. 6', top: '22%', left: '75%' },
        { id: 3, label: 'Pos. 5', top: '32%', left: '75%' },
        { id: 4, label: 'Pos. 3', top: '85%', left: '75%' },
        { id: 5, label: 'Pos. 4', top: '75%', left: '75%' },
        { id: 6, label: 'Pos. 10', top: '22%', left: '90%' },
        { id: 7, label: 'Pos. 9', top: '32%', left: '90%' },
        { id: 8, label: 'Pos. 7', top: '85%', left: '90%' },
        { id: 9, label: 'Pos. 8', top: '75%', left: '90%' },
    ];
    
    const tirePositionsTrailer = [
        { id: 0, label: 'Pos. 1', top: '80%', left: '8%' },
        { id: 1, label: 'Pos. 2', top: '80%', left: '22%' },
        { id: 2, label: 'Pos. 5', top: '85%', left: '8%' },
        { id: 3, label: 'Pos. 6', top: '85%', left: '22%' },
        { id: 4, label: 'Pos. 3', top: '80%', left: '78.5%' },
        { id: 5, label: 'Pos. 4', top: '80%', left: '92%' },
        { id: 6, label: 'Pos. 7', top: '85%', left: '78.5%' },
        { id: 7, label: 'Pos. 8', top: '85%', left: '92%' },
    ];
    
    // Elegir arreglo según tipo de unidad
    const tirePositions = unitType === 'tractor' ? tirePositionsTruck : tirePositionsTrailer;

    // Validar si currentStep es null antes de generar el esquema
    const validationSchema = currentStep
    ? Yup.object().shape({
        ...(currentStep.photoRequired
            ? {
                [photoKey]: Yup.array()
                    .min(1, "Se requiere al menos una foto")
                    .required("Se requiere al menos una foto"),
            }
            : {}),
        ...(currentStep.inputs
            ? currentStep.inputs.reduce((schema, input) => {
                schema[input.key] =
                    input.type === "text"
                        ? Yup.string().required(`${input.label} es obligatorio`)
                        : input.type === "number"
                            ? Yup.number()
                                .required(`${input.label} es obligatorio`)
                                .typeError(`${input.label} debe ser un número válido`)
                            : input.type === "numberFormat"
                                ? Yup.string()
                                    .required(`${input.label} es obligatorio`)
                                    .typeError(`${input.label} debe ser un número válido`)
                                : input.type === "select"
                                    ? Yup.string()
                                        .oneOf(["EBT", "TEDEL", "EXTERNO"], "Debes seleccionar una opción válida")
                                        .required(`Debes seleccionar un valor para ${input.label}`)
                                    : input.type === "autocomplete"
                                        ? Yup.string().test(
                                            "not-empty",
                                            "Debe seleccionar una opción válida",
                                            (value) => value !== "" // Verifica que el valor no sea vacío
                                            ).required(`Debes seleccionar un valor para ${input.label}`)
                                        : input.type === "qr"
                                            ? Yup.string()
                                                .required("Debe escanear un código QR válido")
                                                .min(3, "El código QR debe tener al menos 6 caracteres")
                                                : null;

                // ⚡ Agregamos validación específica para "odometerNumber"
                if (input.key === "odometerNumber") {
                    schema[input.key] = Yup.string()
                        .required(`${input.label} es obligatorio`)
                        .test(
                            "is-valid-number",
                            `${input.label} debe ser un número válido`,
                            (value) => {
                                if (!value) return false; // Si está vacío, es inválido
                                const numberValue = parseFloat(value.replace(/,/g, "")); // Quitar comas y convertir a número
                                return !isNaN(numberValue); // Verificar que sea un número válido
                            }
                        )
                        .test(
                            "min-value",
                            `El odómetro no puede ser menor o igual a 0`,
                            (value) => {
                                if (!value) return false;
                                const numberValue = parseFloat(value.replace(/,/g, ""));
                                return numberValue > 0; // No permite 0 ni valores negativos
                            }
                        );
                }

                return schema;
            }, {})
            : {}),
    })
    : Yup.object(); // Vacío si no hay paso actual

    useEffect(() => 
    {
        const checkUnidadAsignada = async () => 
        {
            const ultimaQR = sessionStorage.getItem('qrPendienteAsignado');
            
            if (!ultimaQR) 
                return;

            try 
            {
                const res = await myApi.get(`/alta_unidad/verificarUnidadQRExistente?qr=${ultimaQR}`);
                
                if (res.data.unidad) 
                {
                    const confirmar = await Swal.fire({
                        title: `QR ya asignado`,
                        html: `¿Deseas continuar el alta con la unidad <strong>${res.data.unidad}</strong>?`,
                        icon: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Sí, continuar',
                        cancelButtonText: 'Cancelar'
                    });

                    if (confirmar.isConfirmed) 
                    {
                        setStepData([{
                            inputs: { unidadSeleccionada: res.data.unidad }
                        }]);
                        setCurrentStepIndex(1);
                    } 
                    else 
                    {
                        sessionStorage.removeItem('qrPendienteAsignado');
                    }
                }
            } 
            catch (e) 
            {
                console.error("Error al verificar unidad previa:", e);
            }
        };

        checkUnidadAsignada();
    }, []);

    useEffect(() => {
        const qr = sessionStorage.getItem('qrPendienteAsignado');
        const unidad = sessionStorage.getItem('unidadAsignada');

        if (qr && unidad) {
            setStepData((prev) => {
            const updated = [...prev];
            updated[0] = {
                stepId: 1,
                ...(updated[0] || {}),
                inputs: {
                ...(updated[0]?.inputs || {}),
                unidadSeleccionada: unidad,
                },
            };
            return updated;
            });

            setCurrentStepIndex(1);
        }
    }, []);

    return (
        <Box
            sx={{
                p: 2,
                minHeight: '100vh',
                maxHeight: '100vh', 
                overflowY: 'auto',
                WebkitOverflowScrolling: 'touch',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Navbar />
            {!unitType ? (
                <Card sx={{ maxWidth: "100%", mx: "auto", p: 3, textAlign: "center" }}>
                    <CardContent>
                        <Typography variant="h6">Seleccione un tipo</Typography>
                        <FormControl fullWidth sx={{ mt: 3 }}>
                            <InputLabel>Tipo de Unidad</InputLabel>
                            <Select
                                value={unitType || ""}
                                onChange={(e) => handleOnChangeUnitType(e.target.value)}
                            >
                                <MenuItem value="tractor">Tractor</MenuItem>
                                <MenuItem value="remolque">Caja</MenuItem>
                            </Select>
                        </FormControl>
                    </CardContent>
                </Card>
            ) : currentStep ? (
                <Formik
                    enableReinitialize // Habilita la reinicialización de valores iniciales
                    initialValues={
                        stepData[currentStepIndex] || {
                            idUser: idUser,
                            [currentStep?.photoKey || "photos"]: [],
                            unitType: unitType,
                            ...(currentStep?.inputs || []).reduce((acc, input) => { acc[input.key] = ""; return acc; }, {}),
                        }
                    }
                    validationSchema={validationSchema}
                    onSubmit={handleNext}
                >
                    
                    {({ values, errors, touched, setFieldValue, isSubmitting, setTouched }) => (
                        <Form>
                            <Grid2 container justifyContent="center">
                                <Grid2 size={{ xs: 12, sm: 10, md: 8 }}>
                                    {/* {unitType && stepData?.[0]?.qrNumber && ( */}
                                    {unitType && stepData?.[0]?.inputs?.unidadSeleccionada && (
                                        <Typography
                                            variant="h5"
                                            textAlign="center"
                                            fontWeight="bold"
                                            mb={2}
                                        >
                                            {/* Bienvenido, está dando de alta el {unitType === "tractor" ? "TRACTOR" : "REMOLQUE"} {stepData[0].qrNumber} */}
                                            Bienvenido, está dando de alta el {unitType === "tractor" ? "TRACTOR" : "REMOLQUE"} {stepData[0].inputs.unidadSeleccionada}
                                        </Typography>
                                    )}

                                    <Card
                                        sx={{ maxWidth: "100%", mx: "auto", p: 3, textAlign: "center" }}
                                    >
                                        <CardContent>
                                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center", gap: 0.5 }}>
                                                <Typography variant="h6" component="span" sx={{ textAlign: "center" }}>
                                                    {`${currentStep.title}`}
                                                </Typography>
                                                

                                            </Box>
                                            <Typography
                                                variant="body2"
                                                color="textSecondary"
                                                mt={2}
                                            >
                                                {currentStep.description}
                                            </Typography>
                                            {currentStep.photoRequired && (
                                                <Box mt={2}>
                                                    {/* Imagen opcional arriba del botón */}
                                                    {currentStep.photoExample && (
                                                    <img
                                                        src={currentStep.photoExample}
                                                        alt="Ejemplo visual"
                                                        style={{
                                                        maxWidth: "100%",
                                                        height: "auto",
                                                        marginBottom: "16px",
                                                        borderRadius: "8px",
                                                        }}
                                                    />
                                                    )}
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        multiple
                                                        capture="environment"
                                                        onChange={(e) => {
                                                            handlePhotoUpload(e, values, setFieldValue, photoKey);
                                                            e.target.value = null;
                                                        }}
                                                        style={{ display: "none" }}
                                                        id={`upload-photos-${photoKey}`}
                                                    />
                                                    <label htmlFor={`upload-photos-${photoKey}`}>
                                                        <Button
                                                            variant="outlined"
                                                            component="span"
                                                            fullWidth
                                                            sx={{ height: { xs: "50px", sm: "50px", md: "50px", lg: "50px" } }}
                                                        >
                                                            Tomar Fotos
                                                        </Button>
                                                    </label>
                                                    {touched[photoKey] && errors[photoKey] && (
                                                        <Typography color="error" mt={1}>
                                                            {errors[photoKey]}
                                                        </Typography>
                                                    )}
                                                    <Grid2 container spacing={2} mt={2}>
                                                        {(values[photoKey] || []).map((photo, index) => (
                                                                <Grid2
                                                                    size={{ xs: 6, sm: 4 }}
                                                                    key={index}
                                                                >
                                                                    <Box position="relative">
                                                                        <CardMedia
                                                                            component="img"
                                                                            height="100"
                                                                            image={photo.url}
                                                                            alt={`Foto ${index + 1}`}
                                                                            sx={{
                                                                                borderRadius: 2,
                                                                                objectFit: "cover",
                                                                                width: "100%",
                                                                                height: "100px",
                                                                            }}
                                                                        />
                                                                        <IconButton
                                                                            onClick={() => {
                                                                                const updatedPhotos = values[photoKey].filter((_, i) => i !== index);
                                                                                
                                                                                // 1. Actualiza Formik
                                                                                setFieldValue(photoKey, updatedPhotos);
                                                                              
                                                                                // 2. Actualiza el stepData también
                                                                                const updatedStepData = [...stepData];
                                                                                updatedStepData[currentStepIndex] = {
                                                                                  ...values,
                                                                                  [photoKey]: updatedPhotos,
                                                                                };
                                                                                setStepData(updatedStepData);
                                                                            }}
                                                                            sx={{
                                                                                position:
                                                                                    "absolute",
                                                                                top: 0,
                                                                                right: 0,
                                                                                backgroundColor:
                                                                                    "rgba(255, 255, 255, 0.8)",
                                                                            }}
                                                                        >
                                                                            <DeleteIcon
                                                                                color="error"
                                                                            />
                                                                        </IconButton>
                                                                    </Box>
                                                                </Grid2>
                                                            )
                                                        )}
                                                    </Grid2>
                                                </Box>
                                            )}
                                            {currentStep.photoTiresTopView && (
                                                <Box mt={2}>
                                                    <Typography variant="subtitle1" gutterBottom>
                                                    Toma fotos desde la vista aérea por llanta
                                                    </Typography>

                                                    <Box
                                                    sx={{
                                                        position: 'relative',
                                                        width: '100%',
                                                        maxWidth: 500,
                                                        mx: 'auto',
                                                        borderRadius: 2,
                                                        overflow: 'hidden',
                                                    }}
                                                    >
                                                    {/* Imagen aérea del camión */}
                                                    <img
                                                        src={currentStep.photoExample}
                                                        alt=
                                                        {
                                                            unitType === "tractor"
                                                            ? "Vista aérea del camión"
                                                            : "Vista aérea del remolque"
                                                        }
                                                        style={{ width: '100%', display: 'block' }}
                                                    />

                                                    {tirePositions.map((pos) => {
                                                    const tire = values.topTirePhotos?.[pos.id] || {};
                                                    const hasAnyData = tire.marca_id || (tire.fotos && tire.fotos.length > 0);
                                                    const isComplete = tire.marca_id && tire.fotos && tire.fotos.length > 0;

                                                    let bgColor = "red";
                                                    let tooltip = "Sin registrar";
                                                    let animation = "blinker 1s linear infinite";

                                                    if (isComplete) {
                                                        bgColor = "green";
                                                        tooltip = "Completo";
                                                        animation = "none";
                                                    } else if (hasAnyData) {
                                                        bgColor = "orange";
                                                        tooltip = "Faltan datos o foto";
                                                    }

                                                    return (
                                                        <Tooltip key={pos.id} title={tooltip} arrow>
                                                        <Button
                                                            variant="contained"
                                                            size="small"
                                                            sx={{
                                                            position: 'absolute',
                                                            top: pos.top,
                                                            left: pos.left,
                                                            transform: 'translate(-50%, -50%)',
                                                            fontSize: '10px',
                                                            padding: '3px 6px',
                                                            backgroundColor: bgColor,
                                                            animation,
                                                            '@keyframes blinker': {
                                                                '50%': { opacity: 0.4 },
                                                            },
                                                            }}
                                                            onClick={() => {
                                                            setSelectedTireIndex(pos.id);
                                                            setSelectedTireLabel(pos.label);
                                                            setModalOpen(true);
                                                            }}
                                                        >
                                                            {pos.label}
                                                        </Button>
                                                        </Tooltip>
                                                    );
                                                    })}
                                          

                                                   
                                                    </Box>

                                                </Box>
                                                )}
                                            {currentStep.inputs &&
                                                currentStep.inputs.map((input) => (
                                                    <Box key={input.key} mt={2}>
                                                        {(() => {
                                                            switch (input.type) {
                                                                case "qr":
                                                                    return (
                                                                        <Box
                                                                            sx={{
                                                                                display: 'flex',
                                                                                flexDirection: 'column',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                height: '100%',
                                                                            }}
                                                                        >
                                                                            <MyQRScanner
                                                                                onScan={async (code) => {
                                                                                    console.log(code);

                                                                                    //setFieldValue(input.key, code);

                                                                                    

                                                                                    // Evitá revalidar el mismo código más de una vez si ya está en el form
                                                                                    //if (values[input.key] === code) return;

                                                                                    // Marcar como touched para que se muestren errores si hay
                                                                                    setTouched({ [input.key]: true });

                                                                                    //const encontrado = await findTractor(code);

                                                                                    let encontrado = true;

                                                                                    /*
                                                                                    if (unitType === "tractor") {
                                                                                        encontrado = await findTractor(code);
                                                                                    } 
                                                                                    else if (unitType === "remolque") {
                                                                                        encontrado = await findTrailer(code);
                                                                                    }
                                                                                        */

                                                                                    if (encontrado) {
                                                                                        setFieldValue(input.key, code);
                                                                                        setSelectedTireLabel(code);
                                                                                        setSelectedTireIndex(unitType);
                                                                                        setModalOpen2(true);
                                                                                    } else {
                                                                                        // Borra el valor si no existe
                                                                                        setFieldValue(input.key, "");
                                                                                    }
                                                                                }}
                                                                            />
                                                                            {touched[input.key] && errors[input.key] && (
                                                                                <Box sx={{ color: 'error.main', mt: 1 }}>
                                                                                    {errors[input.key]}
                                                                                </Box>
                                                                            )}
                                                                        </Box>
                                                                    );
                                                                case "text":
                                                                    return (
                                                                        <Field
                                                                            as={TextField}
                                                                            name={input.key}
                                                                            label={input.label}
                                                                            type="text"
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            error={touched[input.key] && Boolean(errors[input.key])}
                                                                            helperText={touched[input.key] && errors[input.key]}
                                                                        />
                                                                    );
                                                                case "number":
                                                                    return (
                                                                        <MyNumberInput
                                                                            name={input.key}
                                                                            label={input.label}
                                                                            type="number"
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            error={touched[input.key] && Boolean(errors[input.key])}
                                                                            helperText={touched[input.key] && errors[input.key]}
                                                                        />
                                                                    );
                                                                case "numberFormat":
                                                                    return (
                                                                        <MyNumberInputFormat
                                                                            name={input.key}
                                                                            label={input.label}
                                                                            type="text"
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            error={touched[input.key] && Boolean(errors[input.key])}
                                                                            helperText={touched[input.key] && errors[input.key]}
                                                                        />
                                                                    );
                                                                case "select":
                                                                    return (
                                                                        <FormControl fullWidth>
                                                                            <InputLabel>{input.label}</InputLabel>
                                                                            <Field
                                                                                as={Select}
                                                                                name={input.key}
                                                                                value={values[input.key]}
                                                                                onChange={(e) =>
                                                                                    setFieldValue(input.key, e.target.value)
                                                                                }
                                                                            >
                                                                                {input.options.map((option, idx) => (
                                                                                    <MenuItem key={idx} value={option}>
                                                                                        {option}
                                                                                    </MenuItem>
                                                                                ))}
                                                                            </Field>
                                                                        </FormControl>
                                                                    );
                                                            }
                                                        })()}
                                                    </Box>
                                            ))}
                                        </CardContent>
                                    </Card>
                                    <Box
                                        mt={2}
                                        display="flex"
                                        justifyContent="space-between"
                                        sx={{
                                            flexDirection: { xs: "column", sm: "row" },
                                            gap: { xs: 2, sm: 0 },
                                        }}
                                    >
                                        {/* Solo muestra Anterior si el paso es 1 (id 1) */}
                                        {currentStep.id === 1 && (
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() => {
                                                    if (currentStepIndex === 0) {
                                                        setUnitType(null);
                                                        setStepData([]);
                                                    } else {
                                                        handlePrev();
                                                    }
                                                }}
                                                fullWidth
                                                sx={{ marginRight: 2 }}
                                            >
                                                Anterior
                                            </Button>
                                        )}

                                        {/* Cambia el botón a GUARDAR verde grande desde id 2 en adelante */}
                                        {/* {currentStepIndex !== steps.length - 1 && (
                                            <Button
                                                variant="contained"
                                                color={currentStep.id >= 2 ? "success" : "primary"}
                                                type="submit"
                                                fullWidth
                                                size={currentStep.id >= 2 ? "large" : undefined}
                                            >
                                                {currentStep.id >= 2 ? "GUARDAR" : "Siguiente"}
                                            </Button>
                                        )} */}

                                        {/* Botón principal */}
                                        {currentStepIndex !== steps.length - 1 && (
                                            <Button
                                                variant="contained"
                                                color={currentStep.id >= 2 ? "success" : "primary"}
                                                type="submit"
                                                fullWidth
                                                size={currentStep.id >= 2 ? "large" : undefined}
                                            >
                                                {currentStep.id >= 2
                                                    ? (!currentStep.photoRequired && !currentStep.inputs ? "OK" : "GUARDAR")
                                                    : "Siguiente"}
                                            </Button>
                                        )}

                                        {/* <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => {
                                                if (currentStepIndex === 0) {
                                                  setUnitType(null);
                                                  setStepData([]); 
                                                } else {
                                                  handlePrev();
                                                }
                                            }}
                                            fullWidth
                                            sx={{ marginRight: 2 }}
                                            >
                                            Anterior
                                        </Button>
                                        {currentStepIndex !== steps.length - 1 && (
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                type="submit"
                                                disabled={currentStepIndex === steps.length - 1}
                                                fullWidth
                                            >
                                                Siguiente
                                            </Button>
                                        )} */}
                                        {/* {currentStepIndex === steps.length - 1 && (
                                            <Button
                                              variant="contained"
                                              color="primary"
                                              onClick={() => {
                                                const tires = values.topTirePhotos || [];
                                                const { isValid, incompleteLabels } = validateTires(tires, tirePositions);
                                            
                                                if (!isValid) {
                                                  Swal.fire({
                                                    icon: 'error',
                                                    title: 'Llantas incompletas',
                                                    html: `Faltan datos en las siguientes posiciones: <strong>${incompleteLabels.join(', ')}</strong>`,
                                                  });
                                                  return;
                                                }
                                            
                                                handleSubmitForm(values);
                                              }}
                                              fullWidth
                                            >
                                              Finalizar
                                            </Button>
                                        )} */}
                                        {currentStepIndex === steps.length - 1 && (
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={async () => {
                                                const tires = values.topTirePhotos || [];
                                                const { isValid, incompleteLabels } = validateTires(tires, tirePositions);

                                                if (!isValid) {
                                                    Swal.fire({
                                                    icon: 'error',
                                                    title: 'Llantas incompletas',
                                                    html: `Faltan datos en las siguientes posiciones: <strong>${incompleteLabels.join(', ')}</strong>`,
                                                    });
                                                    return;
                                                }

                                                setIsSubmitting(true); 
                                                await handleSubmitForm(values);
                                                setIsSubmitting(false); 
                                                }}
                                                disabled={isSubmitting}
                                                startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : null}
                                                fullWidth
                                            >
                                                {isSubmitting ? 'Guardando...' : 'Finalizar'}
                                            </Button>
                                        )}
                                    </Box>
                                </Grid2>
                            </Grid2>
                            <TireModal
                                open={modalOpen}
                                onClose={() => setModalOpen(false)}
                                index={selectedTireIndex}
                                label={selectedTireLabel}
                                values={values}
                                setFieldValue={setFieldValue}
                                setStepData={setStepData}  
                                steps={steps}            
                                currentStepIndex={currentStepIndex} 
                                stepData={stepData}  
                            />
                            <AssignModal
                                open={modalOpen2}
                                onClose={() => setModalOpen2(false)}
                                index={selectedTireIndex}
                                label={selectedTireLabel}
                                setCurrentStepIndex={setCurrentStepIndex}
                                setStepData={setStepData}
                            />
                        </Form>
                    )}
                </Formik>
            ) : (
                <Typography variant="h6" textAlign="center">
                    No hay pasos disponibles para este tipo de unidad.
                </Typography>
            )}
        </Box>  
              
    );
}
export default Login